import { AxiosResponse } from 'axios';

import { CheckLogin, OutletCrew } from '../pages/outlet-crew/Home.type';
import { axiosInstance } from './axios.config';
import { ResponseREST } from './response.type';

interface ResponseSuccessPostRefreshtoken extends ResponseREST {
	accessToken: string;
	refreshToken: string;
	data: Array<OutletCrew>;
}

export const checkLogin = async (
	body: CheckLogin,
): Promise<ResponseSuccessPostRefreshtoken> => {
	return axiosInstance
		.post('check-user-login', body)
		.then((res: AxiosResponse<ResponseSuccessPostRefreshtoken>) => res.data)
		.catch((err) => err);
};
